import { render, staticRenderFns } from "./MultipleLookups.vue?vue&type=template&id=3029a4ce&scoped=true"
import script from "./MultipleLookups.vue?vue&type=script&lang=js"
export * from "./MultipleLookups.vue?vue&type=script&lang=js"
import style0 from "./MultipleLookups.vue?vue&type=style&index=0&id=3029a4ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3029a4ce",
  null
  
)

export default component.exports